import React from "react"

import { useApiContextSlug } from "~/api"
import { CaseType } from "~/api/types/Case"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"

import styles from "./index.module.css"

export const Case: React.FC<CaseType> = ({ code, previewPicture, name, tags, descInList }) => {
  const slug = useApiContextSlug()

  return (
    <Card className={styles.Wrapper} link={`/${slug}/cases/${code}`}>
      {previewPicture && (
        <div className={styles.Image}>
          <img src={previewPicture} />
        </div>
      )}

      <div className={styles.Inner}>
        <div className={styles.Top}>
          {tags && tags.length !== 0 && (
            <div className={styles.Tag} dangerouslySetInnerHTML={{ __html: tags[0].name }} />
          )}

          <Heading like="h2">{name}</Heading>
        </div>

        {descInList && (
          <div className={styles.Description} dangerouslySetInnerHTML={{ __html: descInList }} />
        )}
      </div>
    </Card>
  )
}
